import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthForm from '../../components/auth/authForm/AuthForm';
import AuthLinkGroup from '../../components/auth/AuthLinkGroup/AuthLinkGroup';
import AuthWrapper from '../../components/auth/authWrapper/AuthWrapper';
import { useLangContext } from '../../context/LangProvider';
import {
  clearError,
  resetHasNewPassword,
  resetNewPasswordToken,
} from '../../redux/auth/authActions';
import {
  getAuthError,
  getHasNewPassword,
  getMustTakeToken,
} from '../../redux/auth/authSelectors';
import { getFormOptions } from '../../components/auth/helpers/authFormOptions';
import { routes } from '../../routes/mainRoutes';

const AuthPage = () => {
  const dispatch = useDispatch();
  const { language } = useLangContext();
  const history = useHistory();
  const { url } = useRouteMatch();
  const authError = useSelector(getAuthError);
  const mustTakeToken = useSelector(getMustTakeToken);
  const hasNewPassword = useSelector(getHasNewPassword);

  const [errorData, setErrorData] = useState({});

  const formOptions = useMemo(() => getFormOptions(url), [url]);

  useEffect(() => {
    const errorStatus = authError?.status;

    const resetError = () => {
      setTimeout(() => {
        dispatch(clearError());
        setErrorData({});
      }, 3000);
    };

    switch (errorStatus) {
      case 409:
        setErrorData({
          email: language.validation.userExists,
        });
        resetError();
        break;
      case 403:
        setErrorData({
          password: language.validation.wrongPassword,
        });
        resetError();
        break;
      default:
        break;
    }
  }, [authError, dispatch, language]);

  useEffect(() => {
    mustTakeToken &&
      url === routes.SEND_EMAIL &&
      toast.success(language.authForm.sendEmailMessage);
  }, [mustTakeToken, language, url]);

  useEffect(() => {
    hasNewPassword && history.push(routes.LOGIN);
  }, [hasNewPassword, history, dispatch]);

  useEffect(() => {
    if (hasNewPassword && url === routes.LOGIN) {
      toast.success(language.authForm.passwordResetMessage);
      dispatch(resetHasNewPassword());
    } else if (mustTakeToken && url !== routes.SEND_EMAIL) {
      dispatch(resetNewPasswordToken());
    }
  }, [hasNewPassword, mustTakeToken, url, language, dispatch]);

  return (
    <AuthWrapper>
      <AuthForm
        errorData={errorData}
        matchUrl={url}
        formOptions={formOptions}
      />
      <AuthLinkGroup matchUrl={url} />
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        pauseOnHover
        draggable={60}
        transition={Flip}
        theme="light"
        icon={true}
      />
    </AuthWrapper>
  );
};

export default AuthPage;
